import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';

export interface LabelQuestionConfig extends WorkflowQuestionConfig {
  labels: Array<{ id: string; name: string }>;
}

export interface LabelResponseState extends WorkflowResponseState {
  labels: Array<{ id: string; name: string }>;
}
